export default "__VITE_ASSET__V8Wta1md__"